import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const CarHireIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M17.1 20.1c-.8 0-1.8.6-2.2 1.3l-3.4 6.5c-.4.7-1.4 1.3-2.2 1.3s-1.8.6-2.2 1.3l-.3.6c-.4.7-.1 1.3.7 1.3s1.1.6.7 1.3l-.2.4c-.4.7-.7 2-.7 2.8v10.7c0 .8.7 1.5 1.5 1.5h2.1c.8 0 1.5-.7 1.5-1.5v-.4c0-.8.7-1.5 1.5-1.5h22.6c.8 0 1.5.7 1.5 1.5v.4c0 .8.7 1.5 1.5 1.5h2.1c.8 0 1.5-.7 1.5-1.5v-9.5c0-.8-.3-2.1-.7-2.9l-.6-1.3c-.4-.7-.1-1.4.7-1.4s1.1-.6.8-1.4l-.3-.7c-.3-.8-1.2-1.4-2-1.4s-1.8-.6-2.2-1.4l-3.2-6.4c-.4-.7-1.3-1.4-2.2-1.4H17.1z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M17.1 20.1c-.8 0-1.8.6-2.2 1.3l-3.4 6.5c-.4.7-1.4 1.3-2.2 1.3s-1.8.6-2.2 1.3l-.3.6c-.4.7-.1 1.3.7 1.3s1.1.6.7 1.3l-.2.4c-.4.7-.7 2-.7 2.8v10.7c0 .8.7 1.5 1.5 1.5h2.1c.8 0 1.5-.7 1.5-1.5v-.4c0-.8.7-1.5 1.5-1.5h22.6c.8 0 1.5.7 1.5 1.5v.4c0 .8.7 1.5 1.5 1.5h2.1c.8 0 1.5-.7 1.5-1.5v-9.5c0-.8-.3-2.1-.7-2.9l-.6-1.3c-.4-.7-.1-1.4.7-1.4s1.1-.6.8-1.4l-.3-.7c-.3-.8-1.2-1.4-2-1.4s-1.8-.6-2.2-1.4l-3.2-6.4c-.4-.7-1.3-1.4-2.2-1.4H17.1z"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M12.8 33.1h26"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M18.4 36.9h13.4"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M18.4 39.7h13.4"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <circle
        cx="13.5"
        cy="38.4"
        fill="none"
        r="2.5"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeMiterlimit="10"
        strokeWidth=".5"
      />
      <circle
        cx="37.1"
        cy="38.4"
        fill="none"
        r="2.5"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeMiterlimit="10"
        strokeWidth=".5"
      />
      <path
        d="M16 30.1c-.8 0-1.2-.6-.9-1.3l1.8-4c.3-.7 1.3-1.3 2.1-1.3h12.6c.8 0 1.7.6 2.1 1.3l1.8 4c.3.7 0 1.3-.8 1.3H16z"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M17 1.1c-4.5 0-8.2 3.7-8.1 8.3.1 4.3 3.7 7.8 8 7.8 3.1 0 5.8-1.7 7.2-4.3h3.8l.8-.8 2.5 1.7 1.7-2.5 2.9 2.5 6.1-4.4-3.7-3.7c-.1-.1-.3-.2-.5-.2H24.1c-1.4-2.7-4-4.4-7.1-4.4z"
        fill="#ffffff"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#000000"
        strokeMiterlimit="10"
        strokeWidth="1.7014"
      />
      <circle cx="17" cy="9.2" fill="#E81C30" className={styles.accentColor} r="3.9" />
    </Icon>
  )
}
